import React from 'react';
import { Link } from 'react-router-dom';
import { SiQuora, SiThreads } from 'react-icons/si';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Scroll to top when footer link is clicked
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <footer className="buyer-footer">
      {/* Decorative Top Wave */}
      <div className="buyer-footer-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
        </svg>
      </div>

      <div className="buyer-footer-container">
        {/* Main Footer Content */}
        <div className="buyer-footer-main">
          {/* About Section with Logo */}
          <div className="buyer-footer-column buyer-footer-about">
            <div className="buyer-footer-logo">
              <img src="/logoswhite.png" alt="India Propertys" className="buyer-footer-logo-image" />
            </div>
            <p className="buyer-footer-description">
              Vedant Infoedge India LLP is a trusted real estate platform dedicated to helping buyers, sellers, and renters connect seamlessly. We provide verified property listings, transparent pricing, and expert support to make real estate transactions simpler, safer, and faster. Whether you're searching for your dream home or the perfect commercial space, we are here to guide you every step of the way.
            </p>
          </div>

          {/* Quick Links */}
          <div className="buyer-footer-column">
            <h3 className="buyer-footer-heading">
              <span>Quick Links</span>
            </h3>
            <ul className="buyer-footer-links">
              <li>
                <Link to="/buyer-about" onClick={handleLinkClick}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                  <span>About Us</span>
                </Link>
              </li>
              <li>
                <Link to="/BuyerContactPage" onClick={handleLinkClick}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                  <span>Contact</span>
                </Link>
              </li>
              <li>
                <Link to="/buyer-privacy-policy" onClick={handleLinkClick}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                  <span>Privacy Policy</span>
                </Link>
              </li>
              <li>
                <Link to="/buyer-terms-conditions" onClick={handleLinkClick}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                  <span>Terms & Conditions</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="buyer-footer-column">
            <h3 className="buyer-footer-heading">
              <span>Contact Info</span>
            </h3>
            <ul className="buyer-footer-contact">
              <li>
                <a href="mailto:info@360coordinates.com" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <div className="buyer-contact-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="buyer-contact-text">
                    <span className="buyer-contact-label">Email</span>
                    <span className="buyer-contact-value">info@360coordinates.com</span>
                  </div>
                </a>
              </li>
              <li>
                <div className="buyer-contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div className="buyer-contact-text">
                  <span className="buyer-contact-label">Address</span>
                  <span className="buyer-contact-value">Pune , Maharashtra, India</span>
                </div>
              </li>
            </ul>

            {/* Social Media */}
            <div className="buyer-footer-social">
              <a
                href="https://www.facebook.com/profile.php?id=61587038531317"
                target="_blank"
                rel="noopener noreferrer"
                className="buyer-social-link facebook"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="#1877F2"
                    d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/360_coordinates"
                target="_blank"
                rel="noopener noreferrer"
                className="buyer-social-link instagram"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="#E4405F"
                    d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
                  />
                </svg>
              </a>

              <a
                href="https://www.youtube.com/@360coordinates"
                target="_blank"
                rel="noopener noreferrer"
                className="buyer-social-link youtube"
                aria-label="YouTube"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="#FF0000"
                    d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                  />
                </svg>
              </a>

              

              <a
                href="https://x.com/360coordinates"
                target="_blank"
                rel="noopener noreferrer"
                className="buyer-social-link x-twitter"
                aria-label="X (Twitter)"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="#000000"
                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                  />
                </svg>
              </a>

              <a
                href="https://www.threads.com/@360coordinates"
                target="_blank"
                rel="noopener noreferrer"
                className="buyer-social-link threads"
                aria-label="Threads"
              >
                <SiThreads aria-hidden="true" focusable="false" />
              </a>

              <a
                href="https://www.quora.com/profile/360coordinates"
                target="_blank"
                rel="noopener noreferrer"
                className="buyer-social-link quora"
                aria-label="Quora"
              >
                <SiQuora aria-hidden="true" focusable="false" color="#B92B27" />
              </a>

              <a
                href="https://in.pinterest.com/360coordinates/"
                target="_blank"
                rel="noopener noreferrer"
                className="buyer-social-link pinterest"
                aria-label="Pinterest"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="#E60023"
                    d="M12 0C5.37 0 0 5.37 0 12c0 4.99 3.06 9.26 7.41 11.08-.1-.94-.19-2.38.04-3.41.2-.88 1.29-5.6 1.29-5.6s-.33-.66-.33-1.64c0-1.53.89-2.67 2-2.67.94 0 1.39.7 1.39 1.54 0 .94-.6 2.35-.91 3.66-.26 1.1.55 2 1.63 2 1.96 0 3.46-2.07 3.46-5.06 0-2.65-1.9-4.5-4.62-4.5-3.15 0-5 2.36-5 4.8 0 .95.37 1.97.83 2.52.09.11.1.2.07.31-.08.34-.26 1.1-.29 1.25-.05.2-.16.24-.37.14-1.37-.64-2.23-2.65-2.23-4.27 0-3.47 2.52-6.65 7.27-6.65 3.81 0 6.78 2.72 6.78 6.35 0 3.78-2.38 6.82-5.68 6.82-1.11 0-2.15-.58-2.5-1.27l-.68 2.6c-.25.96-.92 2.17-1.37 2.9C9.69 23.85 10.83 24 12 24c6.63 0 12-5.37 12-12S18.63 0 12 0z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="buyer-footer-bottom">
          <div className="buyer-footer-bottom-content">
            <p className="buyer-footer-copyright">
              © {currentYear} <span className="buyer-copyright-brand">Vedant Infoedge India LLP</span>. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;